import { Fab, Grid, Paper, Tab, Tabs, Theme, Tooltip, Typography, withStyles, TableCell, Table, TableHead, TableRow, TableBody, TableFooter, TablePagination, TextField, FormControl, useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { isBrowser } from 'react-device-detect';
import React, { useGlobal, useDispatch } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import BlockIcon from '@material-ui/icons/Lock'
import {ClearIcon} from '../../icons/icons';
import '../../css/media-query-styles.css';
import { IGlobalState, IMyAppState, initialState, initialStateBudget, initialStateSimulazioniSrl } from '../../states/GlobalState';
import Auth, { getIdentityFromStorage, getLevels } from '../../types/auth';
import { Applicazioni } from '../../types/types';
import { useLogger } from '../../logger';
import TablePaginationActions from '../../pagination/TablePaginationActions';
import { Agency, AgencySearchModel } from '../../models/agency';
import {useHistory} from 'react-router-dom';
import { getAgencies, getAgency } from '../../services/agencyService';
import { useEffect } from 'react';
import { breakpoint } from '../../types/constants';
import { Roles } from '../../models';
import { filterVariants } from '../../animation/variants';
import {motion } from 'framer-motion';
import { globalStyles } from '../../style/GlobalStyles';

const useStyles = makeStyles((theme: Theme) => createStyles({
    tableContainer: {
        width: "100%",
        marginTop: theme.spacing(3),
        overflowX: "auto",
    },
    table: {
        minWidth: 700,
    },
    tablerow: {
        cursor: 'pointer',
    },
    filterContainer: {
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(0),
        display: 'flex',
    },
    fab: {
        textAlign: 'right'
    }
}));

const CustomBlockIcon = withStyles((theme: Theme) => createStyles({
  root: {
      fontSize: 20,
      color: theme.palette.primary.main,
  },
}))(BlockIcon);
const CustomTableCellForIcon = withStyles((theme: Theme) => createStyles({
  body: {
      fontSize: 20,
      textAlign: 'center',
      color: theme.palette.secondary.main,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableCell = withStyles((theme: Theme) => createStyles({
  head: {
      fontSize: 14,
      // backgroundColor: theme.palette.common.black,
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderLeft: 'solid 1px #c0c0c0',
  },
  body: {
      fontSize: 14,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableRow = withStyles((theme: Theme) => createStyles({
  root: {
      color: "inherit",
      display: "table-row",
      outline: "none",
      verticalAlign: "middle",
      height: 28,
  },
}))(TableRow);

export default function AgencyIndex() {
    const theme = useTheme();
    // eslint-disable-next-line
    const [pagination, setPagination] = useGlobal<IGlobalState, 'agencyPagination'>('agencyPagination');
    const [filteredAgencies, setFilteredAgencies] = useGlobal<IGlobalState, 'filteredAgencies'>('filteredAgencies');
    const [application, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    const [loadingAgencies, setLoadingAgencies] = useGlobal<IGlobalState, 'loadingAgencies'>('loadingAgencies');
    const [globalWait, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const [ip, ] = useGlobal<IGlobalState, 'ip'>('ip');
    const [auth, ] = useGlobal<IGlobalState, 'auth'>('auth');
    const [identity, setIdentity] = useGlobal<IGlobalState, 'identity'>('identity');
    const logger = useLogger({key: 'agency'});
    const history = useHistory();
    const dispatch = useDispatch();
    const adLevels = getLevels(auth.authData);
    const classes = useStyles();
    const gClasses = globalStyles();
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
    let model: AgencySearchModel = new AgencySearchModel();
    const [agencyFilter, setAgencyFilter] = useGlobal<IGlobalState, 'agencyFilter'>('agencyFilter');
    let direction: string | undefined = mobile ? "column" : "row";
    //paginazione lato server
    let queryName: string = ''
    let queryId: number = 0
    let pageDirection: string = 'forward'

    const _handleChangePage = (ev: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        debugger;
        setPagination({...pagination, page});
        if (page > pagination.page) {
            pagination.direction = 'forward';
            queryName = filteredAgencies && filteredAgencies.length > 0 ? filteredAgencies.slice(-1)[0].Name : '';
            queryId = filteredAgencies && filteredAgencies.length > 0 ? filteredAgencies.slice(-1)[0].Id : 0;
            pageDirection = 'forward';
        }
        else
        {
            pagination.direction = 'back';
            queryName = filteredAgencies && filteredAgencies.length > 0 ? filteredAgencies[0].Name : '';
            queryId = filteredAgencies && filteredAgencies.length > 0 ? filteredAgencies[0].Id : 0;
            pageDirection = 'back';
        }

        model.QueryName = queryName;
        model.QueryId = queryId;
        model.PageDirection = pageDirection;

        handleSearch();
    }
    const _handleChangeRowsPerPage = (ev: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>) => setPagination({...pagination, rowsPerPage: parseInt(ev.target.value)})
  
    const _handleRowClick = (ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>, agency: Agency) => {
        if(globalWait) {return;}
        console.log(`_handleRowClick.${agency.Id}`, {agency})
        setGlobalWait(true);
        pagination.querySurname = queryName;
        pagination.queryId = queryId;
        getAgency(ip, auth.authData!, auth.user!, agency.Id).then((ag: Agency)  => {
            if(ag) {
                dispatch.setCurrentEditAgencyAndMode(ag, 'Edit');
                history.push(`/agencyDetail/${agency.Id}`);
            } else {
                // notifyUser(`Company con oid = ${company.Id} non trovata`, 'error')
                logger.error('Errore in recupero agency non trovata avente id: ' + agency.Id);
            }
        }).finally(() => setGlobalWait(false));
    }

    const handleAdd = () => {
        console.log('*** +++ handleAdd Agency')
        const newOid = 0;
        const livelloDefault = adLevels ? adLevels[0].value as number : 0;
        
        //TODO GESTIRE NELLO STATO ma da fare prima ??
        dispatch.createNewAgency(newOid);
        history.push(`/agencyDetail/${newOid}`);
    }
  
    const handleSearch = () => {
        debugger;
        setLoadingAgencies(true);
        model.Name = agencyFilter.name;
        model.Code = agencyFilter.code;
        model.VatNumber = agencyFilter.vatNumber;
        model.Take = pagination.rowsPerPage;
        if (!model.PageDirection || model.PageDirection === '' ) model.PageDirection = pageDirection

        getAgencies(ip, auth.authData!, auth.user!, model).then(res => {
            console.log('Ritorno le agency ' + JSON.stringify(res));            
            setFilteredAgencies(res.ResultList as Agency[]);
            if (res.ResultList && res.ResultList.length > 0) {
                pagination.rows = res.ListLength;
            }
        }).catch(error => {
            logger.error('Errore in recupero agency: ' + error.statusText);
        })
        .finally(() => setLoadingAgencies(false));
    }

    const handleClear = () => {
        setAgencyFilter({name: '', code: '', vatNumber: ''});
    }

    const handleChangeFilter = (e: any) => {
        let { name, value } = e.target;
        // console.log('Filter username SERIALIZZATO: ' + value);
        setAgencyFilter({...agencyFilter, name: value});
    }

    const handleChangeFilterCode = (e: any) => {
        let { name, value } = e.target;
        setAgencyFilter({...agencyFilter, code: value});
    }

    const handleChangeFilterVat = (e: any) => {
        let { name, value } = e.target;
        setAgencyFilter({...agencyFilter, vatNumber: value});
    }

    useEffect(() => {
        //debugger;
        queryName = pagination.querySurname
        queryId = pagination.queryId;
        
        setApplication(Applicazioni.Agency);
    }, []);

  return (
    <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
        <IForfettariAppBar title="Gestione studi" handleLoad={() => {}}></IForfettariAppBar>
        <Main>
        <div className={gClasses.rootModel}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', float: 'left', flex: '0 1 auto'}}>
            <div style={{display: 'flex', flexDirection: direction, justifyContent: 'flex-start', float: 'left', flex: '0 1 auto'}}>
                {/* <UserLoader /> */}
                <motion.div variants={filterVariants}
                        initial="hidden"
                        animate="visible"
                        style={{ flex: '0 1 auto'}}>
                    <h3>
                        Filtri
                    </h3>
                </motion.div>
                &nbsp;
                <div className={classes.filterContainer}>
                    <TextField onChange={handleChangeFilter} color='primary' label="Nome" value={agencyFilter.name} 
                        InputLabelProps={{
                            shrink: true,            
                        }}/>
                </div>
                <div className={classes.filterContainer}>
                    <TextField onChange={handleChangeFilterCode} color='primary' label="Codice" value={agencyFilter.code} 
                        InputLabelProps={{
                            shrink: true,            
                        }}/>
                </div>
                <div className={classes.filterContainer}>
                    <FormControl style={{ minWidth: '150px'}}>
                        <TextField onChange={handleChangeFilterVat} color='primary' label='P.iva' value={agencyFilter.vatNumber}
                        InputLabelProps={{
                            shrink: true,            
                        }}/>
                    </FormControl>
                </div>
            </div>
            <motion.div variants={filterVariants}
                initial="hidden"
                animate="visible"
                style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                {/* <div style={{ flex: '1 1' }}>&nbsp;</div> */}
                <div style={{ flex: '0 1 auto' }}>
                    <Fab color='default' size='small' className={classes.fab} title="Pulisci filtri"
                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleClear()}>
                        <ClearIcon />
                    </Fab>
                </div>
                {identity && identity.Role === Roles.SUPERADMIN ?
                <>
                &nbsp;
                <div style={{ flex: '0 1' }}>
                    <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}>
                        <AddIcon titleAccess="Aggiungi studio"/>
                    </Fab>
                </div>
                </>
                : null}
                &nbsp;
                <div style={{ flex: '0 1' }}>
                    <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                        pageDirection = 'forward'
                        queryName= '';
                        queryId = 0;
                        handleSearch()
                    }}
                    >
                        <SearchIcon titleAccess="Ricerca studio"/>
                    </Fab>
                </div>
            </motion.div>
            </div>
            <Paper className={classes.tableContainer}>
                <Table className={classes.table} size='small'>
                    <TableHead>
                        <TableRow>
                          <CustomTableCell>&nbsp;</CustomTableCell>
                          <CustomTableCell>Id</CustomTableCell>
                          <CustomTableCell>Nome</CustomTableCell>
                          <CustomTableCell>Company</CustomTableCell>
                          <CustomTableCell>Partita Iva</CustomTableCell>
                          <CustomTableCell>Codice</CustomTableCell>
                          <CustomTableCell>Indirizzo</CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {!loadingAgencies && filteredAgencies && filteredAgencies.length 
                        //? (filteredAgencies.slice(pagination.page * pagination.rowsPerPage, pagination.page * pagination.rowsPerPage + pagination.rowsPerPage).map(agency => (
                        ? (filteredAgencies.map(agency => (
                            <TableRow hover={true} key={agency.Id} onClick={(ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => _handleRowClick(ev, agency)} className={classes.tablerow}>
                                <CustomTableCellForIcon>
                                  {agency.State === 'D' && <CustomBlockIcon titleAccess='Studio disabilitato' color="primary"/>}
                                </CustomTableCellForIcon>
                                <CustomTableCell>{agency.Id}</CustomTableCell>
                                <CustomTableCell>{agency.Name}</CustomTableCell>
                                <CustomTableCell>{agency.Company?.BusinessName}</CustomTableCell>
                                <CustomTableCell>{agency.VatNumber}</CustomTableCell>
                                <CustomTableCell>{agency.Code}</CustomTableCell>
                                <CustomTableCell>{agency.Address}</CustomTableCell>
                            </TableRow>
                        ))) 
                        : <CustomTableRow>
                              <CustomTableCell colSpan={5}>
                              <Typography variant="h6" color="textSecondary">{loadingAgencies ? "Caricamento..." : "Nessun dato da visualizzare"}</Typography>
                            </CustomTableCell>
                        </CustomTableRow>}
                    </TableBody>
                    <TableFooter>
                        <CustomTableRow>
                          <CustomTableCell colSpan={6}>
                              <TablePagination
                                  rowsPerPageOptions={[10,20,30, { label: 'All', value: -1 }]}
                                  count={pagination.rows ? pagination.rows : 0}
                                  rowsPerPage={pagination.rowsPerPage}
                                  page={pagination.page}
                                  SelectProps={{native: true,}}
                                  onChangePage={_handleChangePage}
                                  onChangeRowsPerPage={_handleChangeRowsPerPage}
                                  //ActionsComponent={TablePaginationActions}
                                  labelRowsPerPage="Righe per pagina"
                                  labelDisplayedRows={({ from, to, count }) => count ? `${from}-${to} di ${count}` : ""}
                                  component='div'
                                  style={{display: 'flex'}}
                              />
                          </CustomTableCell>
                      </CustomTableRow>
                    </TableFooter>
                </Table>
            </Paper>
        </div>
        </Main>
    </div>
  );
}